

























import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import { expandArrayToMap } from "@root/lib/utils.ts";

@Component({})
export default class GtTabs extends Vue {
  // 默认高亮的 tab
  @Prop({ default: true, type: Boolean }) needTopMargin;
  // 默认高亮的 tab
  @Prop({ default: "", type: [String, Number] }) activeName;
  // tab 类型
  @Prop({ default: "card", type: String }) type;
  // 是否有按钮样式会有略微差异
  @Prop({ default: false, type: Boolean }) hasButton;
  // tabList
  @Prop({ default: () => [], type: Array }) tabList;
  // statusCountList tab中有些状态需要统计数量
  @Prop({ default: () => [], type: Array }) statusCountList;

  private newActName: String = "";
  private newTabList: any = [];

  created() {
    this.newTabList = this.tabList || [];
    this.newActName = this.activeName + "" || "#";
  }

  get statusCountListCom() {
    let { statusCountList = [], tabList = [] } = this;

    if (tabList && tabList.length === 0) return [];
    if (statusCountList && statusCountList.length === 0) return tabList;

    let countListMap = expandArrayToMap(statusCountList, {
      labelKey: "qty",
      valueKey: "status"
    });

    let arr = tabList.map((v, i) => {
      let { value, label } = v;
      let item = { ...v };

      if (countListMap[value] != undefined) {
        let qty = countListMap[value];
        item["qty"] = qty;
      }

      return item;
    });

    return arr;
  }

  // mounted() {
  //   console.log(this.statusCountListCom, this.newTabList);
  // }

  @Watch("activeName")
  onActiveNameWatcher(val, oldVal) {
    this.newActName = this.activeName + "" || "#";
  }

  handleClickTab() {
    let sendParentDate = this.newActName == "#" ? "" : this.newActName;
    this.$emit("click", sendParentDate);
  }
}
